module.exports = __webpack_public_path__ + "static/media/frame-contender.3eb9f4ea.png";